export default "__VITE_ASSET__ce0cfe0a__"